module.exports = __webpack_public_path__ + "img/Ativo 7@150x-8.83f392e8.png";